module.exports = __webpack_public_path__ + "0-es2015.29c8ca5bce6d71171c65.worker.js"